import { render, staticRenderFns } from "./TerminsAndCondition.vue?vue&type=template&id=39964347"
import script from "./TerminsAndCondition.vue?vue&type=script&lang=js"
export * from "./TerminsAndCondition.vue?vue&type=script&lang=js"
import style0 from "./TerminsAndCondition.vue?vue&type=style&index=0&id=39964347&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports